import { render, staticRenderFns } from "./politicas.vue?vue&type=template&id=352971d0&"
import script from "./politicas.vue?vue&type=script&lang=js&"
export * from "./politicas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports